import { render, staticRenderFns } from "./Assessments.vue?vue&type=template&id=12213b5a&scoped=true&"
import script from "./Assessments.vue?vue&type=script&lang=js&"
export * from "./Assessments.vue?vue&type=script&lang=js&"
import style0 from "./Assessments.vue?vue&type=style&index=0&id=12213b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12213b5a",
  null
  
)

export default component.exports